import './ComponentAttributesPanel.scss';

export { default as ComponentAttributesPanel } from './ComponentAttributesPanel';
export { default as getComponentAttributesPanelSchema } from './componentAttributesSchema';
